import { render } from "./AddIncident.vue?vue&type=template&id=e97c40ea&ts=true"
import script from "./AddIncident.vue?vue&type=script&lang=ts"
export * from "./AddIncident.vue?vue&type=script&lang=ts"

import "./AddIncident.vue?vue&type=style&index=0&id=e97c40ea&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__